import router from "@/router";
import store from "@/store";
import axios from "axios";
import { Message } from "element-ui";
// let preUrl = "/frontendDev"; //本地开发给代理替换的前缀
// let preUrl = "https://marketmanager.jiaxixiang.com/api/dev"; //本地开发给代理替换的前缀
let preUrl = "https://marketmanager.jiaxixiang.com/api"; //生产前缀
// let preUrl = "https://marketmanager.njghxc.com/external-api/dev"; //外部前缀
// 设置全局默认 header
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Accept"] = "application/json";
let http = {
	post: function (url, param, config = {}) {
		// console.log("当前登录token:", "Bearer " + sessionStorage.getItem("token"));
		axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");

		return axios
			.post(preUrl + url, param, config)
			.then(function (res) {
				console.log(url +"请求成功:", res);
				return res; // 👈 关键：把响应返回出去
			})
			.catch(function (error) {
			console.error(url +"请求失败:1", JSON.stringify(error));
			// 可选：抛出错误，让调用方能 catch
			if (error.response && error.response.status == 401) {
				console.error("登陆失效");
				store.commit("CLEAR_AUTH");
				Message({
					message: "登录失效",
					type: "error",
					duration: 1000,
				});
				setTimeout(() => {
					router.push("/login");
				}, 1000);
				return Promise.reject(new Error("登录失效"));
			} else {
				// 其他状态（如 403），显示错误信息
				console.log(error.response);
				if (error.response && error.response.data && error.response.data.data) {
					Message.error(error.response.data.data);
				} else {
					// 对于blob类型的响应，不显示错误信息，因为错误信息在blob中
					if (config.responseType !== 'blob') {
						Message.error("请求失败，请稍后重试");
					}
				}
				return Promise.reject(error);
			}
		});
	},
	get: function (url, config = {}) {
		// console.log("当前登录token:", "Bearer " + sessionStorage.getItem("token"));
		axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");

		return axios
			.get(preUrl + url, config)
			.then(function (res) {
				console.log(url +"请求成功:", res);
				return res; // 👈 关键：把响应返回出去
			})
			.catch(function (error) {
			console.error(url +"请求失败:", JSON.stringify(error));
			// 可选：抛出错误，让调用方能 catch
			if (error.response && error.response.status == 401) {
				console.error("登陆失效");
				store.commit("CLEAR_AUTH");
				Message({
					message: "登录失效",
					type: "error",
					duration: 1000,
				});
				setTimeout(() => {
					router.push("/login");
				}, 1000);
				return Promise.reject(new Error("登录失效"));
			} else {
				// 其他状态（如 403），显示错误信息
				console.log(error.response);
				if (error.response && error.response.data && error.response.data.data) {
					Message.error(error.response.data.data);
				} else {
					// 对于blob类型的响应，不显示错误信息，因为错误信息在blob中
					if (config.responseType !== 'blob') {
						Message.error("请求失败，请稍后重试");
					}
				}
				return Promise.reject(error);
			}
		});
	},
	upload: function (url, formData) {
		// console.log("当前登录token:", "Bearer " + sessionStorage.getItem("token"));
		axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");

		return axios
			.post(preUrl + url, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			})
			.then(function (res) {
				console.log(url +"上传成功:", res);
				return res; // 👈 关键：把响应返回出去
			})
			.catch(function (error) {
			console.error(url +"上传失败:", JSON.stringify(error));
			// 可选：抛出错误，让调用方能 catch
			if (error.response && error.response.status == 401) {
				console.error("登陆失效");
				store.commit("CLEAR_AUTH");
				Message({
					message: "登录失效",
					type: "error",
					duration: 1000,
				});
				setTimeout(() => {
					router.push("/login");
				}, 1000);
				return Promise.reject(new Error("登录失效"));
			} else {
				// 其他状态（如 403），显示错误信息
				console.log(error.response);
				if (error.response && error.response.data && error.response.data.data) {
					Message.error(error.response.data.data);
				} else {
					Message.error("上传失败，请稍后重试");
				}
				return Promise.reject(error);
			}
		});
	},
};
export default http;